import styled, {css} from 'styled-components'
import pxToRem from '../../utils/pxToRem'
import {deviceMax} from '../../theme/breakpoints'

import Chip from '../Chip/Chip'
import Heading from '../Heading/Heading'
import Button from '../Button/Button'
import IconButton from '../IconButton/IconButton'
import ButtonDownload from '../ButtonDownload/ButtonDownload'
import {InternalLink} from '../Link/Link'

export const CardInformationDesktop = styled.div`
  display: block;
  @media ${deviceMax.mobileL} {
    display: none;
  }
`

export const CardInformationMobile = styled.div`
  display: none;
  @media ${deviceMax.mobileL} {
    display: block;
  }
`

export const StyledSearchCard = styled.div`
  flex-direction: column;
  display: flex;
  margin-bottom: ${pxToRem(20)};
  max-width: ${pxToRem(792)};
  border-radius: ${pxToRem(5)};
  padding: ${pxToRem(20)};
  background-color: ${({theme}) => theme.colors.unique.white};
  @media ${deviceMax.mobileL} {
    margin: ${pxToRem(10)};
    ${({$isInvestor}) =>
            $isInvestor &&
            `
    min-width : ${pxToRem(270)};
    `};
  }
`

const TitleStyle = css`
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  margin-bottom: ${pxToRem(10)};
  @media ${deviceMax.mobileL} {
    -webkit-line-clamp: 3;
  }
`

export const StyledTitle = styled(Heading)`
  ${TitleStyle}
`

export const StyledTitleLink = styled(InternalLink)`
  ${TitleStyle}
  padding: initial;
  width: fit-content;
  text-decoration: none;
  font-size: ${({theme}) => theme.fonts.sizes.titleH2.laptop};
  font-weight: ${({theme}) => theme.fonts.weight.bold};
  line-height: ${({theme}) => theme.fonts.lineHeight.titleH2};
  @media ${deviceMax.mobileL} {
    font-size: ${({theme}) => theme.fonts.sizes.titleH3.laptop};
    line-height: ${({theme}) => theme.fonts.lineHeight.titleH3};
  }
`

const StyledText = css`
  font-weight: ${({theme}) => theme.fonts.weight.medium};
  font-size: ${({theme}) => theme.fonts.sizes.base};
  line-height: ${({theme}) => theme.fonts.lineHeight.titleH4};
`

export const StyledParagraph = styled.p`
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  margin-bottom: ${pxToRem(10)};
  color: ${({theme}) => theme.colors.opacity.black70};
  ${StyledText} @media ${deviceMax.mobileL} {
    margin-bottom: ${pxToRem(15)};
  }
`

export const StyledBottomContainer = styled.div`
  align-items: center;
  justify-content: space-between;
  display: flex;
`

export const StyledLeftContainer = styled.div`
  align-items: center;
  flex-wrap: wrap;
  display: flex;
  @media ${deviceMax.mobileL} {
    align-items: flex-start;
    flex-direction: column;
  }
`

export const StyledSeparator = styled.div`
  width: ${pxToRem(20)};
  height: ${pxToRem(2)};
  background-color: ${({theme}) => theme.colors.primary.lime};
  border-radius: ${pxToRem(2)};
  margin-right: ${pxToRem(5)};
`

export const StyledCategories = styled.div`
  align-items: center;
  flex-wrap: wrap;
  display: flex;
  @media ${deviceMax.mobileS} {
    align-items: flex-start;
    flex-direction: column;
  }
`

export const StyledDateContainer = styled.div`
  align-items: center;
  flex-wrap: wrap;
  display: flex;
  @media ${deviceMax.mobileL} {
    margin-bottom: ${pxToRem(15)};
  }
`

export const StyledCategory = styled(Chip)`
  margin: 0 ${pxToRem(5)} 0 ${pxToRem(15)};
  @media ${deviceMax.mobileL} {
    margin: 0 ${pxToRem(10)} ${pxToRem(15)} 0;
  }
`

export const StyledDate = styled.p`
  ${StyledText}
  margin-left: ${pxToRem(10)};
  font-weight: ${({theme}) => theme.fonts.weight.normal};
  @media ${deviceMax.mobileL} {
    margin-left: 0;
  }
`

export const StyledReadMore = styled(Button)`
  padding: ${pxToRem(10.5)} ${pxToRem(25)};
  width: fit-content;
`

export const StyledIconButton = styled(IconButton)``

export const StyledButtonDownload = styled(ButtonDownload)`
  max-width: ${pxToRem(260)};
  height: ${({$isInvestor}) => ($isInvestor ? pxToRem(50) : pxToRem(40))};
`
